import type { i18n as I18nInstance } from "i18next";

import { AVAILABLE_LANGUAGES } from "../constants/languages";

const SUPPORTED_LANGUAGE_CODES = AVAILABLE_LANGUAGES.map((item) => item.value);
const FALLBACK_LANGUAGE_CODE = SUPPORTED_LANGUAGE_CODES[0];

const matchSupportedCode = (candidate: string): string | undefined => {
  if (SUPPORTED_LANGUAGE_CODES.includes(candidate)) {
    return candidate;
  }

  const base = candidate.split("-")[0];
  return SUPPORTED_LANGUAGE_CODES.find(
    (value) => value === base || value.startsWith(`${base}-`),
  );
};

/**
 * Maps i18next's raw `language` / `resolvedLanguage` / fallback chain to one of
 * the canonical codes in AVAILABLE_LANGUAGES (e.g. `en` → `en-US`).
 */
export const normalizeSupportedLanguageCode = (
  candidate: string | null | undefined,
): string | null => {
  if (!candidate) {
    return null;
  }

  return matchSupportedCode(candidate) ?? null;
};

export const resolveSupportedLanguageCode = (i18n: I18nInstance): string => {
  const candidates = [
    i18n.language,
    ...i18n.languages.filter((code) => code !== i18n.language),
    i18n.resolvedLanguage,
  ].filter((code): code is string => Boolean(code));

  for (const candidate of candidates) {
    const match = matchSupportedCode(candidate);
    if (match) {
      return match;
    }
  }

  return FALLBACK_LANGUAGE_CODE;
};
